
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component
class AboutGestalt extends Vue {
}

export default AboutGestalt;
